import React from 'react';
import { MessageCircle } from 'lucide-react';
export function FloatingWhatsApp() {
  return <a href="https://wa.me/59899000000" // Placeholder number
  target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300 flex items-center justify-center group" aria-label="Contactar por WhatsApp" data-id="element-79">
      <MessageCircle size={28} data-id="element-80" />
      {/* Tooltip */}
      <span className="absolute right-full mr-4 bg-charcoal text-white text-sm py-1.5 px-3 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap" data-id="element-81">
        ¡Escribinos!
      </span>
    </a>;
}